var React = require('react');

function Mars (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M143.9 384a80 80 0 1 1 80-80 80 80 0 0 1-80 80z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M371.9 64h-79a12 12 0 0 0-8.5 20.5l16.9 16.9-80.7 80.7a143.94 143.94 0 1 0 45.2 45.2l80.7-80.7 16.9 16.9a12 12 0 0 0 20.5-8.5V76a12 12 0 0 0-12-12zm-228 320a80 80 0 1 1 80-80 80 80 0 0 1-80 80z","className":"fa-primary","key":2})]);
}

Mars.defaultProps = {"viewBox":"0 0 384 512","className":"icon"};

module.exports = Mars;

Mars.default = Mars;
